/* global Tesseract */

let worker

const initialize = async () => {
  worker = await Tesseract.createWorker('eng')
}

const configure = async (withSpace = true) => {
  if (!worker) { await initialize() }
  await worker.setParameters({
    tessedit_pageseg_mode: Tesseract.PSM.SINGLE_LINE,
    tessedit_char_whitelist: '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZÑ)' + (withSpace ? ' ' : '')
  })
}

const extractSingleLine = async (imageData, rectangle, withSpace = true) => {
  await configure(withSpace)
  const ret = await worker.recognize(imageData, { rectangle })
  return withSpace
    ? ret.data.text.trim()
    : ret.data.text.replace(/\s/g, '').trim()
}

const destroy = async () => {
  if (worker) {
    await worker.terminate()
    worker = null
  }
}

module.exports = {
  initialize,
  extractSingleLine,
  destroy
}
